const CLAIMED = 'claimed';
const CHECKED_IN = 'checked_in';

export const RIDE_STATES = {
  upcoming: ['in_cart', 'unclaimed'],
  claimed: [CLAIMED, CHECKED_IN],
  inProgress: ['in_progress', 'waiting'],
  completed: ['completed', 'complete'],
  canceled: ['canceled'],
  inactive: ['inactive'],
};
